import { Button } from "@/components/ui/button";
import { Day } from "../../../-types";
import { useReservationFormContext } from "../contex";
import { Check, Trash, Undo } from "lucide-react";
import { T } from "@/i18n";
import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Activities } from "./activities";
import { Accommodations } from "./accommodations";

export function Details({ day }: { day: Day }) {
  const { scheduleManager } = useReservationFormContext();
  return (
    <div className="grid gap-4">
      <div className="flex items-center justify-between gap-2">
        <Name
          value={day.reservationDay.value.name}
          onChange={(nm) => {
            scheduleManager.handleDayNameChange(
              day.reservationDay.value.day,
              nm,
            );
          }}
        />
        <Button
          variant="text-destructive"
          size="icon"
          className="m-1"
          onClick={() =>
            scheduleManager.handleDeleteDay(day.reservationDay.value.day)
          }
        >
          <Trash />
          <span className="sr-only">
            <T tKey="reservations.form.schedule.delete" />
          </span>
        </Button>
      </div>
      <Accommodations
        reservationId={day.reservationDay.value.reservationId}
        day={day.reservationDay.value.day}
        accommodations={day.accommodations.map(({ value }) => value)}
      />
      <Activities
        reservationId={day.reservationDay.value.reservationId}
        day={day.reservationDay.value.day}
        services={day.services.map(({ value }) => value)}
      />
    </div>
  );
}

function Name({
  value,
  onChange,
}: {
  value: string | null | undefined;
  onChange: (nm: string) => void;
}) {
  const [name, setName] = useState<string | null | undefined>(value);
  const [edit, setEdit] = useState(false);

  if (!edit) {
    return (
      <Button
        variant="text"
        type="button"
        className="m-1 w-fit p-0"
        onClick={() => setEdit(true)}
      >
        <T tKey="reservations.form.schedule.updateName" />
      </Button>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <Input
        id="name"
        className="w-2/5"
        value={name ?? value ?? ""}
        onChange={(ev) => {
          setName(ev.target.value);
        }}
      />
      <Button
        disabled={name === value}
        variant="text"
        type="button"
        className="m-1 w-fit"
        onClick={() => {
          onChange(name ?? "");
          setEdit(false);
        }}
      >
        <Check />
      </Button>
      <Button
        variant="text-destructive"
        type="button"
        className="m-1 w-fit"
        onClick={() => {
          setName(value);
          setEdit(false);
        }}
      >
        <Undo />
      </Button>
    </div>
  );
}
